export default __webpack_public_path__ + "static/media/type_17_2.a513733e.svg";